// Styles for WebPromptBanner go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledWebPromptBanner = styled.div`
  .card {
    width: 100%;
    border-radius: ${toRem(14)};
    background-color: ${baseVariables.color.base20};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
    position: relative;
  }

  .icon {
    span {
      font-size: ${toRem(24)};
    }
    &-clear {
      font-size: ${toRem(24)};
      background-color: ${baseVariables.color.base20};
    }
    height: ${toRem(48)};
    width: ${toRem(48)};
    padding: ${toRem(12)};
    align-items: center;
    justify-content: center;
    border: ${toRem(1.2)} solid ${baseVariables.color.neutral20};
    border-radius: ${toRem(8)};
  }

  .banner-content {
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
    @media ${baseVariables.mediaQuery.lg} {
      flex-direction: row;
      align-items: center;
    }
    &-description {
      color: ${baseVariables.color.neutral40};
      line-height: ${toRem(21)};
    }
  }
  
   &.web-prompt-static-banner {
    .m-link-tertiary-button,
    .m-link-tertiary-button-external,
    [data-testid='webPromptBannerCta'],
    [data-testid='webPromptBannerCta'] * {
      white-space: normal !important;
      margin-right: 0 !important;
    }
  }

`;
